import React, { useState } from 'react'
import classNames from 'classnames'
import { Dropdown, Menu } from 'antd'
import ModalConfirm from '../../components/ModalConfirm'
import Icon from '../../components/Icon'
import {
  ReactComponent as UserSupport,
} from '../../components/Icon/user-support.svg'
import styled from 'styled-components'

const styleForIcon = {
  fontSize: 18,
  verticalAlign: 1,
  marginRight: 5,
}

const ItemOfGroups = styled.div`
    color: ${(props) => props.theme.colorTable.text}
    background: ${(props) => props.theme.colorTable.plain} &: hover {
    background: ${(props) => props.theme.colorTable.backLightHover}
}

    &.accent {
        color: ${(props) => props.theme.colorTable.listSelectionText}
        background: ${(props) => props.theme.colorTable.listSelection}
    }
`

const Card = ({
  name,
  setActive,
  index,
  isActive,
  isRemove,
  remove,
  iconType,
  type,
  support = false,
}) => {
  if (!iconType) {
    iconType = 'icon-users'
  }
  const [isHide, setIsHide] = useState(-1)
  return (
    <ItemOfGroups onClick={() => setActive(index)}
                  onMouseOut={() => setIsHide(-1)}
                  onMouseOver={() => setIsHide(index)}
                  className={classNames(
                    'col-12 border collectionItem p-3  d-flex justify-content-between text-truncate cursorPointer',
                    { accent: isActive }, { 'border-top-0': index > -1 })}
    >
      <div>
        {support ? (<UserSupport style={styleForIcon}/>) : (
          <Icon type={iconType} style={styleForIcon}/>)}
        {name}
      </div>
      {isRemove && (
        <div className={classNames({ invisible: index !== isHide },
          { visible: index === isHide })}
             onClick={e => {
               e.preventDefault()
               e.stopPropagation()
             }}
        >
          <Dropdown overlay={
            <Menu>
              <Menu.Item>
                <ModalConfirm
                  title={`Are you sure you want to permanently delete the ${type
                    ? type
                    : 'group'}?`}
                  submit={() => {
                    remove(index)
                    setActive('everyone')
                  }}
                >
                  <span><Icon type="icon-trash"
                              style={{
                                fontSize: 14,
                                verticalAlign: '0.1em',
                              }}/><span> Delete {type
                    ? type
                    : 'group'}</span></span>
                </ModalConfirm>
              </Menu.Item>
            </Menu>}
          >
            <Icon type="icon-more" style={{
              fontSize: 18,
              verticalAlign: '0.1em',
            }}/>
          </Dropdown>
        </div>
      )}
    </ItemOfGroups>
  )
}

export default Card
